module.exports = "<svg viewBox=\"0 0 37 35\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.61 12.09v22.9h7.37v-22.9H1.61zm19.166 9.603c0-2.954 1.884-4.432 4.095-4.432 2.213 0 4.015 1.48 4.015 5.172V34.99h7.37V21.692c0-6.648-3.684-10.34-8.845-10.34-2.948 0-5.16 1.682-6.634 3.898l-.246-3.16h-7.25c0 .78.124 5.17.124 5.17v17.73h7.372V21.692zM5.254 8.398c2.744 0 4.464-1.806 4.464-4.063C9.678 2.037 7.998.273 5.336.273 2.633.273.872 2.037.872 4.335c0 2.257 1.72 4.063 4.34 4.063h.042z\" fill=\"currentColor\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/linkedin.svg
// module id = Ocgb
// module chunks = 89